import { IDocumentTypeRepository } from "domain/contracts/document-type.contracts";
import { DocumentType } from "domain/entities/document-type";
import { DocumentTypeInputFilter } from "domain/models/document-type-input-filter";
import { Message } from "../../domain/entities/message";
import { httpClient } from "../axios/axios-api";

class DocumentTypeRepository implements IDocumentTypeRepository {
  async getAll(
    filter: DocumentTypeInputFilter
  ): Promise<Message<DocumentType[]>> {
    const response = await httpClient.get(`/documentType`, {
      params: filter,
    });
    return response.data;
  }

  async create(input: DocumentType): Promise<Message<DocumentType>> {
    const response = await httpClient.post(`/documentType`, { data: input });
    return response.data;
  }

  async update(input: DocumentType): Promise<Message<boolean>> {
    const response = await httpClient.put(`/documentType/${input.id}`, {
      data: input,
    });
    return response.data;
  }

  async delete(id: string): Promise<Message<boolean>> {
    const response = await httpClient.delete(`/documentType/${id}`);
    return response.data;
  }
}

export default new DocumentTypeRepository();
